import {Room} from "colyseus.js";
import {MoveCommand, prettyMoveCommand} from "../model/messages";
import {KitchenState} from "../model/state";
import {mainLogger} from "./client_logger";


const logger = mainLogger.child({level: 'info', label: 'client.messenger'})

export class Messenger {

    room: Room<KitchenState> | any | undefined

    constructor(room: Room<KitchenState> | any | undefined) {
        this.room = room
    }

    send_move_command(command: MoveCommand) {
        if (this.room == null) return;
        this.room.send("moved", command);
        logger.debug(`sent moved command ${prettyMoveCommand(command)}`)
    }

    setRoom(room) {
        this.room = room
    }

    sendPickOrDrop() {
        this.room.send('pick')
        logger.debug(`sent pick`)
    }

    sendChopStart(stationId: string) {
        this.room.send('chopStart', { stationId })
        logger.debug(`sent chopStart for station ${stationId}`)
    }

    sendChopStop() {
        this.room.send('chopStop')
        logger.debug(`sent chopStop`)
    }

    sendStartRound() {
        this.room.send('start_round')
        logger.debug(`sent start_round`)
    }
}
